import { Label } from '@/components/ui/label';
import { useAuth } from '@/context/AuthContext';
import EditProfile from './EditProfile';
import { FileText } from 'lucide-react';

export default function MRProfile() {
  const { user } = useAuth();

  return (
    <div className="max-w-2xl">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-heading font-bold text-background-dark">Profile Information</h2>
        <EditProfile />
      </div>

      <div className="bg-white rounded-xl border border-slate-200 p-8">
        {user?.mr_photo && (
          <div className="flex justify-center mb-6">
            <img
              src={user.mr_photo}
              alt="MR photo"
              className="h-40 w-40 rounded-full object-cover border-4 border-primary/20"
            />
          </div>
        )}

        <div className="space-y-6">
          <div>
            <Label>Full Name</Label>
            <p className="mt-2 text-slate-900 font-medium">{user?.full_name}</p>
          </div>

          <div>
            <Label>Email</Label>
            <p className="mt-2 text-slate-900">{user?.email}</p>
          </div>

          <div>
            <Label>Phone</Label>
            <p className="mt-2 text-slate-900">{user?.phone}</p>
          </div>

          <div>
            <Label>Company Name</Label>
            <p className="mt-2 text-slate-900 font-medium">{user?.company_name}</p>
          </div>

          <div>
            <Label>Division</Label>
            <p className="mt-2 text-slate-900 font-medium">{user?.division}</p>
          </div>

          <div>
            <Label>City</Label>
            <p className="mt-2 text-slate-900">{user?.city}</p>
          </div>

          {user?.mr_visiting_card && (
            <div>
              <Label>Visiting Card</Label>
              <div className="mt-2">
                {user.mr_visiting_card.startsWith('data:application/pdf') ? (
                  <a
                    href={user.mr_visiting_card}
                    download="visiting_card.pdf"
                    className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-hover transition-colors"
                  >
                    <FileText className="h-4 w-4" />
                    Download Visiting Card (PDF)
                  </a>
                ) : (
                  <img
                    src={user.mr_visiting_card}
                    alt="Visiting Card"
                    className="max-w-md rounded-lg border border-slate-200"
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
